/**
 * Assume zero when a number is so tiny it is just dust.
 * @param {number} value - The value to check
 * @returns {number} The value if it is greater than 0.000001, otherwise 0 
 */
export const effectZero = (value: number): number => {
	if(Number.isNaN(value)) return 0;
	if(value < 0.000001 && value > -0.000001) return 0;
	if(value === Infinity || value === -Infinity) return 0;
	return value;
}

export const effectZeroBigInt = (value: bigint, decimals: number, precision: number = 5 ): bigint => {
	return value < BigInt(10**(decimals-precision)) ? BigInt(0) : value;
}
